export const IMAGES = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/gif',
    'jpg',
    'jpeg',
    'png',
    'gif',
];

export const DOCS = [
    'doc',
    'docx',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'pages',
    'application/pages',
    'application/x-iwork-pages-sffpages',
    'rtf',
    'text/rtf',
];

export const PDF = [
    'pdf',
    'application/pdf',
];



// WEBPACK FOOTER //
// ./src/common/constants/fileTypes.js